import { createGlobalStyle } from 'styled-components'

const ShowCaptcha = createGlobalStyle`
.grecaptcha-badge { 
    visibility: visible !important;
  }
`

export default ShowCaptcha
